var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976311 10.3096C1.60143 9.6845 2.44928 9.33331 3.33333 9.33331H8C8.88406 9.33331 9.7319 9.6845 10.357 10.3096C10.9821 10.9347 11.3333 11.7826 11.3333 12.6666V14C11.3333 14.3682 11.0349 14.6666 10.6667 14.6666C10.2985 14.6666 10 14.3682 10 14V12.6666C10 12.1362 9.78929 11.6275 9.41421 11.2524C9.03914 10.8774 8.53043 10.6666 8 10.6666H3.33333C2.8029 10.6666 2.29419 10.8774 1.91912 11.2524C1.54405 11.6275 1.33333 12.1362 1.33333 12.6666V14C1.33333 14.3682 1.03486 14.6666 0.666667 14.6666C0.298477 14.6666 0 14.3682 0 14V12.6666C0 11.7826 0.35119 10.9347 0.976311 10.3096Z",
    fill: "#FB7B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 2.66665C4.5621 2.66665 3.66667 3.56208 3.66667 4.66665C3.66667 5.77122 4.5621 6.66665 5.66667 6.66665C6.77124 6.66665 7.66667 5.77122 7.66667 4.66665C7.66667 3.56208 6.77124 2.66665 5.66667 2.66665ZM2.33333 4.66665C2.33333 2.8257 3.82572 1.33331 5.66667 1.33331C7.50762 1.33331 9 2.8257 9 4.66665C9 6.5076 7.50762 7.99998 5.66667 7.99998C3.82572 7.99998 2.33333 6.5076 2.33333 4.66665Z",
    fill: "#FB7B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8047 5.52858C16.0651 5.78892 16.0651 6.21103 15.8047 6.47138L13.1381 9.13805C12.8777 9.3984 12.4556 9.3984 12.1953 9.13805L10.8619 7.80472C10.6016 7.54437 10.6016 7.12226 10.8619 6.86191C11.1223 6.60156 11.5444 6.60156 11.8047 6.86191L12.6667 7.72384L14.8619 5.52858C15.1223 5.26823 15.5444 5.26823 15.8047 5.52858Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activate-icon.9cd28bdde888f3a7f689e6fcfa7360ba.svg";
export { ForwardRef as ReactComponent };